import React from 'react';
import { LlmModel, useLlmModelsService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import { formatModelPrice } from '../../llmPriceUtils';
import styles from '../ChatWidget.module.scss';

interface ModelSelectorProps {
  className?: string;
}

export default function ModelSelector(props: ModelSelectorProps) {
  const modelsService = useLlmModelsService();
  const { data: models } = useDataLoaderNew<LlmModel[]>(modelsService.getModels);
  const { selectedModelId, setSelectedModelId } = useChatWidgetContext();

  if (!models || models.length === 0) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedModelId(value || null);
  };

  return (
    <select
      className={props.className ?? styles.modelSelector}
      value={selectedModelId ?? ''}
      onChange={handleChange}
      aria-label="Select AI model"
      data-testid="model-selector"
    >
      <option value="">Default model</option>
      {models.map((model) => (
        <option key={model.id} value={model.id}>
          {model.displayName} — {formatModelPrice(model.inputPricePerMillionTokens, model.outputPricePerMillionTokens)}
        </option>
      ))}
    </select>
  );
}
